import driftImg from "./assets/drift.jpg";
import kartImg from "./assets/kart.jpg";
import {CreditPack, ExplainerTitleVariant, Ride} from "pages/Front/Booking/Credits/CreditCalculator/types";

/** Nominal base value used to compute discounts. Not a purchasable SKU. */
export const CREDIT_BASE_VALUE_CHF = 1.0;

export const RIDES: readonly Ride[] = [
    {
        id: "go-kart",
        name: "Go-Kart Fahrt",
        descriptor: "Elektro-Kartbahn, 1 Rennen",
        credits: 18,
        imageSrc: kartImg,
        imageAlt: "Go-Kart Rennen auf der Elektro-Kartbahn",
        infoUrl: "https://www.arbopark.ch/attraktionen/kartbahn/",
    },
    // {
    //     id: "zosh-super-drift",
    //     name: "Zosh Super Drift",
    //     descriptor: "1 Session",
    //     credits: 14,
    //     imageSrc: zoshImg,
    //     imageAlt: "Zosh Super Drift Session",
    //     infoUrl: "https://www.arbopark.ch/attraktionen/zosh/",
    // },
    {
        id: "crazy-drift",
        name: "Crazy Drift",
        descriptor: "1 Fahrt",
        credits: 4,
        imageSrc: driftImg,
        imageAlt: "Crazy Drift Fahrt",
        infoUrl: "https://www.arbopark.ch/attraktionen/driftpark/",
    },
] as const;

/** Cheapest and most expensive single ride, for the "Reicht für" range. */
export const MIN_RIDE_CREDITS = Math.min(...RIDES.map(r => r.credits));
export const MAX_RIDE_CREDITS = Math.max(...RIDES.map(r => r.credits));

/** Packs-only ladder. Single credits are intentionally not sold. */
export const CREDIT_PACKS: readonly CreditPack[] = [
    {credits: 22, priceChf: 17.6, discountLabel: "20%", availability: "standard-family"},
    {credits: 36, priceChf: 25.2, discountLabel: "30%", availability: "standard-family"},
    {credits: 64, priceChf: 38.4, discountLabel: "40%", availability: "standard-family"},
    {credits: 96, priceChf: 52.8, discountLabel: "45%", availability: "family-only"},
    {credits: 128, priceChf: 67.2, discountLabel: "47.5%", availability: "family-only"},
    {credits: 256, priceChf: 128.0, discountLabel: "50%", availability: "family-only"},
] as const;

export const EXPLAINER_TITLES: Record<ExplainerTitleVariant, string> = {
    single: "Wie viele Credits brauche ich?",
    group: "Wie viele Credits brauchen wir?",
};

/**
 * Availability rule: small packs (22/36/64) can be bought with every ticket
 * product; large packs (96/128/256) only with the pooled-wallet tickets
 * (Family Ticket, Happy Kids, Happy Kids plus).
 */
export const AVAILABILITY_LABELS: Record<CreditPack["availability"], string> = {
    "standard-family": "Alle Tickets",
    "family-only": "Family & Happy Kids",
};

export const LADDER_FOOTNOTE = "Grosse Packs gibt es zu Tickets mit gemeinsamem Credits-Guthaben (Family & Happy Kids).";

/**
 * Central place for the credits colour code (red) so a design-token
 * remap touches exactly one file. Yellow remains reserved for Eintritt.
 */
export const CREDITS_CLASSES = {
    text: "text-credits",
    textStrong: "text-credits",
    bg: "bg-credits",
    bgTint: "bg-credits-tint",
    border: "border-credits",
    ring: "focus-visible:ring-credits",
} as const;

/**
 * Ink ramp from the Figma tokens (theme.css). Darkened for contrast:
 * muted text at small sizes now passes WCAG AA.
 */
export const INK_CLASSES = {
    primary: "text-ink",
    secondary: "text-ink-secondary",
    muted: "text-ink-muted",
} as const;
